import * as React from 'react';

import { Title } from '../Title';
import * as styles from './Section.css';

interface ISectionProps {
  children?: React.ReactNode;
  title?: string;
  fullWidth?: boolean;
  dataName?: string;
}

export const Section: React.FC<ISectionProps> = ({ children, title, fullWidth, dataName }) => {
  return (
    <div
      className={fullWidth ? styles['full-width'] : styles['centered']}
      data-name={dataName ? `${dataName}Section` : undefined}
    >
      {title && <Title>{title}</Title>}
      {children}
    </div>
  );
};
